export const FLAVORS = {
  hayday: { name: "hayday", domain: "gohayday.co" },
  pinata: { name: "pinata", domain: "gopinata.com" },
};

export type Flavor = keyof typeof FLAVORS;
